var feiertage=new Array(31);  // in Klammen bitte Anzahl der Feiertage eintragen. Gezaehlt wird ab NULL, von 0 bis 12 sind es 13 Elemente
feiertage[0]="01.01.2016";  
feiertage[1]="06.01.2016";
feiertage[2]="25.03.2016";
feiertage[3]="28.03.2016";
feiertage[4]="01.05.2016";
feiertage[5]="16.05.2016";
feiertage[6]="26.05.2016";
feiertage[7]="15.08.2016";
feiertage[8]="03.10.2016";
feiertage[9]="01.11.2016";
feiertage[10]="25.12.2016";
feiertage[11]="26.12.2016";
feiertage[12]="01.01.2017";
feiertage[13]="06.01.2017";
feiertage[14]="14.04.2017";
feiertage[15]="17.04.2017";
feiertage[16]="01.05.2017";
feiertage[17]="25.05.2017";
feiertage[18]="05.06.2017";
feiertage[19]="15.06.2017";
feiertage[20]="15.08.2017";
feiertage[21]="03.10.2017";
feiertage[22]="31.10.2017";
feiertage[23]="01.11.2017";
feiertage[24]="25.12.2017";
feiertage[25]="26.12.2017";
feiertage[26]="01.01.2018";
feiertage[27]="06.01.2018";
feiertage[28]="30.03.2018";
feiertage[29]="02.04.2018";
feiertage[30]="01.05.2018";

var weekday=new Array(7);
weekday[0]="Sonntag";
weekday[1]="Montag";
weekday[2]="Dienstag";
weekday[3]="Mittwoch";
weekday[4]="Donnerstag";
weekday[5]="Freitag";
weekday[6]="Samstag";

////////////////////////////////////////////
//var d=new Date();

var Wochentag = weekday[deliveryDateObj.getDay()]; 

var noWeekEnd = true;
if ( (deliveryDateObj.getDay() == 0) || (deliveryDateObj.getDay() == 6) ) noWeekEnd = false;

  var Tag = deliveryDateObj.getDate();
         if (Tag<10) Tag='0' + Tag;
  var Monat = deliveryDateObj.getMonth() + 1;
         if (Monat<10) Monat='0' + Monat;
  var Jahr = deliveryDateObj.getFullYear();
  var Datum = Tag + "." + Monat + "." + Jahr

//document.write('Heute ist ' + Wochentag + ', der ' + Datum);
//document.write ('<br>');



var holiday = true;
if (feiertage.indexOf(Datum) < 0) holiday = false;



var retValue = 0;

if (noWeekEnd && !holiday) {

  var Std = deliveryDateObj.getHours();

  if (Std < 14)  	    retValue = 3;
  //else if (Std < 16)  	retValue = 4;
  else if (Std <=23)    retValue = 5;


}
else {
  retValue = 6;

}


function showCountdown (pRetValue){


document.getElementById('countdown').innerHTML = '  Zeit   ';
 //+countdown_d+'</b> '+tage+' und <b>'+ausgabe_h+':'+ausgabe_m+':'+ausgabe_s+'</b> bis '+text[i];
}